import React, { useCallback, useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import messages from './SgSphDeclarationsBullets.messages';

function SgSphDeclarationsBullets(props) {
    const {
        modelVM
    } = props;
    const translator = useContext(TranslatorContext);

    const { buildingsUnderwriter, contentsUnderwriter } = modelVM.value.lobData.privateHome.coverables.propertyDetails;

    const underwriterBullet = useCallback((id, message, underwriter) => {
        const underwriterText = `${underwriter}.`;
        return (
            <li id={id}>
                <span>
                    { translator(message) }
                </span>
                <span>
                    <b>
                        {underwriterText}
                    </b>
                </span>
            </li>
        );
    }, [translator]);

    return (
        <>
            { contentsUnderwriter !== buildingsUnderwriter
                && (
                    <>
                        { buildingsUnderwriter
                            && underwriterBullet('buildingsUnderwriter', messages.BuildingUnderwriter, buildingsUnderwriter) }
                        { contentsUnderwriter
                            && underwriterBullet('contentsUnderwriter', messages.ContentsUnderwriter, contentsUnderwriter) }
                    </>

                )
            }
            { contentsUnderwriter && contentsUnderwriter === buildingsUnderwriter
                    && underwriterBullet('underwriter', messages.ChangedUnderwriter, contentsUnderwriter)
            }
        </>
    );
}

export default SgSphDeclarationsBullets;
